import {observer} from 'mobx-react'
import React from 'react'

import {useFavourite} from '@/src/features/favourite'

export const FavouriteCountContainer = observer((props: React.HTMLProps<HTMLSpanElement>) => {
  const favouriteVm = useFavourite()

  if (favouriteVm.favouriteIds.length === 0) return <span></span>

  return (
    <span {...props} data-testid="favourite-count" suppressHydrationWarning>
      {favouriteVm.favouriteIds.length}
    </span>
  )
})
